import { Component, OnInit } from '@angular/core';
import { UserService } from 'app/layouts/homepage/services/user.service';
import { AuthServerProvider } from 'app/core';
import { SERVER_API_URL } from 'app/app.constants';
import { UserType, UserTypeUtil } from 'app/shared/model/user-type.model';
import { IUser } from 'app/core/user/user.model';

@Component({
    selector: 'jhi-homepage',
    templateUrl: './homepage.component.html',
    styleUrls: ['../../../../../content/scss/styles.scss']
})
export class HomepageComponent implements OnInit {
    public isUserLogged = false;

    loading = false;
    organization: string;
    orgDag = false;
    userType: UserType = UserType.STANDARD;
    userTypeDisplay: string;
    user: IUser;

    constructor(
        private userService: UserService,
        private authService: AuthServerProvider) {

    }

    ngOnInit() {
        if (this.authService.getToken()) {
            this.isUserLogged = true;
            // Only load user info if the user has a valid token (authenticated)
            this.loadUserInfo();
        }
        this.loading = false;

        this.authService
            .organization()
            .toPromise()
            .then(res => {
                this.organization = res.body
                this.checkOrganization(this.organization);
            });
    }

    checkOrganization(organization: string) {
        if(organization.toLowerCase()==='dag'){
            this.orgDag=true;
        }
    }

    loadUserInfo() {
        this.userService.getLogged().subscribe(
            response => {
                this.user = response.body;
                this.isUserLogged = true; // User is logged in via SSO headers
                // Load additional user information
                this.loadUserType();
            },
            error => {
                console.warn('User not logged in or could not load user info', error);
                this.isUserLogged = false;
                this.user = {}; // Initialize as empty object if loading fails
            }
        );
    }

    loadUserType() {
        this.userService.getUserType().subscribe(
            (userType: string) => {
                this.userType = userType as UserType;
                this.userTypeDisplay = UserTypeUtil.getDisplayName(this.userType);
            },
            error => {
                console.warn('Could not load user type, defaulting to STANDARD', error);
                this.userType = UserType.STANDARD;
                this.userTypeDisplay = UserTypeUtil.getDisplayName(this.userType);
            }
        );
    }

    isExtraUeUser(): boolean {
        return UserTypeUtil.isExtraUE(this.userType);
    }

    isEidasUser(): boolean {
        return UserTypeUtil.isEIDAS(this.userType);
    }

    isStandardUser(): boolean {
        return UserTypeUtil.isStandard(this.userType);
    }

    getRedirect(requestUrl: string) {
        // TODO controllare per quale motivo se 401 IE chiede di scaricare
        window.location.href = SERVER_API_URL + 'private/login?targetUrl=' + encodeURIComponent(requestUrl);
    }

    get appUrl() {
        return this.authService.appUrl;
    }

    backToApp() {
        const appUrl = this.authService.appUrl;
        window.location.href = SERVER_API_URL + 'public/back?appUrl=' + encodeURIComponent(appUrl);
    }
}
